// removed by extract-text-webpack-plugin
module.exports = {"card":"_2YeqjiBQNBc_H5a2uPCjPt","toolbar":"_1AG37psVtbTrF5v1qGN1-k","noInvoices":"_3kOCwBga6W1CACRjcUsCT-"};


//////////////////
// WEBPACK FOOTER
// ./src/views/CreateBillingOrder/PickDebtPhases/styles.css
// module id = 1085
// module chunks = 0